import { normalize } from 'normalizr'
import { Schemas } from 'redux/schema'
import { updateEntities, deleteEntity } from 'redux/entities'

import apiV2 from 'utils/apiV2'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/team/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/team/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/team/FETCH_FAILURE'

const CREATE_REQUEST = 'contenthouse/team/CREATE_REQUEST'
const CREATE_SUCCESS = 'contenthouse/team/CREATE_SUCCESS'
const CREATE_FAILURE = 'contenthouse/team/CREATE_FAILURE'

const UPDATE_REQUEST = 'contenthouse/team/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'contenthouse/team/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'contenthouse/team/UPDATE_FAILURE'

const DELETE_REQUEST = 'contenthouse/team/DELETE_REQUEST'
const DELETE_SUCCESS = 'contenthouse/team/DELETE_SUCCESS'
const DELETE_FAILURE = 'contenthouse/team/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loaded: false,
  loading: false,
  result: {},
  updating: false,
}

// Actions
export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest() {
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess() {
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []) {
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest() {
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess() {
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []) {
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest() {
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess() {
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []) {
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Action Creators
export function loadTeams(options) {
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = apiV2('/teams', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data ? data : [], Schemas.TEAM_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(data))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function createTeam(team, options = {}) {
  const config = {
    method: 'POST',
    data: team,
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = apiV2(`/teams`, options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.TEAM)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, result: data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function updateTeam(team, options = {}) {
  const config = {
    method: 'PUT',
    data: team,
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = apiV2(`/teams/${team.id}`, options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.TEAM)
        const updateEntityOptions = {
          mergeOptions: {
            customMerge: () => (_, source) => source,
          },
        }

        dispatch(updateEntities(normalizedJson, updateEntityOptions))
        dispatch(updateSuccess())

        return { success: true, result: data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function deleteTeam(team) {
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const promise = apiV2(`/teams/${team.id}`, { permanent: true }, config)
      .then(() => {
        const normalizedJson = normalize(team, Schemas.TEAM)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        return { success: true, result: team }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(deleteFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { type, payload, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
        result: payload,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors,
      }
    case DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors,
      }
    default:
      return state
  }
}
